var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"department-editor-root"},[_c('button',{on:{"click":function($event){return _vm.clear()}}},[_vm._v("クリア")])])}
var staticRenderFns = []

export { render, staticRenderFns }